import { SUBSCRIPTION_URL } from 'src/config/api.config';
import ApiService from './Api.service';

class SubscriptionService extends ApiService {
  constructor() {
    super(SUBSCRIPTION_URL);
  }
}

export default new SubscriptionService();
